<template>
  <md-card>

      <!-- <md-dialog-alert
      :md-active.sync="first"
      md-content=""
      md-confirm-text="Cool!" /> -->

    <md-dialog :md-active.sync="first">

     <!-- {{ product.idsymbol }} {{ cbComparison }} -->
      <md-dialog-actions>
        <md-button class="md-primary" @click="first = false">zamknij</md-button>
      </md-dialog-actions>
      <md-dialog-title><b>{{product.symbol}}</b> - {{product.nazwa}}</md-dialog-title>

        <img v-if="product.symbol" :src="$url_img(product.symbol)">

    </md-dialog>

    <a :href="`https://www.pulsar.pl/${$i18n.locale.toUpperCase()}_9999_${product.symbol}_`" target="_blank">
      <!-- {{product.tabs}} -->
      <md-card-header>
        <div id="tabs-content">

          <!-- <span v-if="product.tabs.phone == 1" class="tabs tabs-phone" :title="$t('phone')">
            <md-tooltip md-direction="top">{{$t('phone')}}</md-tooltip>
          </span> -->
          <!-- <span v-if="product.obnizka == 1" class="tabs tabs-reduce" :title="$t('reduce')">
            <md-tooltip md-direction="top">{{$t('reduce')}}</md-tooltip>
          </span>
          <span v-if="product.podwyzka == 1" class="tabs tabs-rises" :title="$t('rises')">
            <md-tooltip md-direction="top">{{$t('rises')}}</md-tooltip>
          </span>-->
          <span v-if="product.wyprzedaz == 1" class="tabs tabs-sale" :title="$t('sale')"
          style="background: rgb(6, 110, 221);  width: 70px;  position: absolute;  top: 0px;text-align: center;height: 20px;"
          title="">
            <b style="color: white; font-weight: normal;">{{$t('sale')}}</b>
            <!-- <md-tooltip md-direction="top">{{$t('sale')}}</md-tooltip> -->
          </span>
          <span v-if="product.nowosc == 1" class="tabs tabs-news" :title="$t('news')"
          style="background: #fbca3f;  width: 70px;  position: absolute;  top: 0px;text-align: center;height: 20px;"
          :style="((product.wyprzedaz == 1) ? 'right:70px;' : '')">
            <b style="color: rgb(18, 117, 204); font-weight: normal;">{{$t('news')}}</b>
            <md-tooltip md-direction="top">{{$t('news')}}</md-tooltip>
          </span>
          <!-- <span v-if="product.promocja == 1" class="tabs tabs-promotion" :title="$t('promotion')">
            <md-tooltip md-direction="top">{{$t('promotion')}}</md-tooltip>
          </span> -->

        </div>
        <div class="md-title">
          {{product.symbol}}
          <!-- {{ Object.keys(comparisonList).length }} -->
          <!-- <a :href="`https://www.pulsar.pl/PL_9999_${product.symbol}_`" target="_new">{{product.symbol}}</a> -->
        </div>
        <!-- { "sale": null, "rises": null, "reduce": null, "news": null } -->
        <div class="md-subhead">{{product.nazwa}}</div>
      </md-card-header>
      <md-card-media>
        <!-- <md-button class="md-accent md-raised" @click="first = true">Alert</md-button> -->
        <img v-if="product.symbol" v-lazy="$url_img(product.symbol)" class="pic" />
        <!-- <a :href="`${$url_img(product.symbol)}`"> -->
        <!-- </a> -->
      </md-card-media>
    </a>

    <!-- <p v-if="zalogowany" class='price'><span class="textPrice">{{$t('price')}}</span> {{product.tabs.cena | cutDecimal}}</p> -->
    <!-- <p class='price'><span class="textPrice">{{$t('price')}}</span> {{product.tabs.cena | cutDecimal}}</p> -->
    <svg @click="first = true" style="cursor:pointer" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
      <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
    </svg>

    <div v-if="isInsidePoland && $i18n.locale === 'pl'" style="display: grid; position: absolute; right: 0px; text-align: right; padding: 10px; bottom: 5px;">
      <label style="font-size: 11px; color: #a2a2a2;" v-if="product.wyprzedaz == 1" v-html="$t('cena_netto_detal_wyprzedaz')"></label>
      <label style="font-size: 11px; color: #a2a2a2;" v-else v-html="$t('cena_netto_detal')"></label>
      <span style="font-size: 20px;  color: rgb(7, 106, 184);"><em style="font-size: 11px; color: black;">{{ $t("waluta") }}</em> {{formatPrice(product.netto)}}</span>
    </div>
    <div v-if="$comparison" style="height: 20px;  position: absolute;  bottom: 5px;  left: 4px;">
      <!-- <input :name="product.symbol" type="checkbox" v-model="cbComparison" :value="product.symbol" @change="setListComparison(product.symbol)" :disabled="(disabled) ? true : false">
      <label :for="product.symbol" style="font-size: 12px;  color: gray;"> {{ $t("porownaj") }}</label> -->
      <input
        :id="`compare-${product.symbol}`"
        type="checkbox"
        v-model="isChecked"
        :disabled="disabled"
      />
      <label :for="`compare-${product.symbol}`">{{ $t("porownaj") }}</label>
    </div>

  </md-card>
</template>

<script>
import axios from "axios"
import { mapGetters } from "vuex"
import { helpers } from "../mixins/helpers"

export default {
  name: "Product",
  mixins: [helpers],
  props: ["product", "zalogowany", "isInsidePoland"],
  data() {
    return {
      image: "",
      first: false,
      cbComparison: false,
      symbol: null
    };
  },

  filters: {
    cutDecimal(value) {
      var numeral = require("numeral")
      var decim = numeral(value).format("0")
      return decim + ' zł'
    },
  },
  watch: {
    comparisonList (newValue) {
      this.checkInput(newValue)
    }
  },
  computed: {
    ...mapGetters ('products', ["comparisonList"]),
    // symbolProduct () {
    //   return this.product.idsymbol
    // },
    isChecked: {
      get() {
        return this.comparisonList.includes(this.product.symbol)
      },
      set(val) {
        if (val) {
          this.$store.commit('products/SET_COMPARISONS', this.product.symbol)
        } else {
          this.$store.commit('products/REMOVE_COMPARISON', this.product.symbol)
        }
      }
    },
    disabled () {
      // console.log(this.comparisonList)
      // console.log(this.symbol)
      if (Object.keys(this.comparisonList).length < 3 || this.comparisonList.includes(this.product.symbol)) {
        return false
      }
      return true
    }
  },
  //---------------------------------------------------------
  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatPrice(value) {
      return parseFloat(value).toFixed(2);
    },
    roundTo (num, places) {
      const factor = 10 ** places
      const price = Math.round(num * factor) / factor
      let str = price.toString()

      if (!str.includes('.') && !str.includes(',')) {
        str += '.00'
      }
      return str
    },

    $url_img(elem) {
      //let prod = (elem.indexOf('/'))?elem.replace('/',','):elem;
      let prod = this.slash_to_comma(elem)
      return process.env.VUE_APP_ROOT_IMG + prod + "_1.png"
    },
    setListComparison (id) {
      this.$store.commit('products/SET_COMPARISONS', id)
    },
    checkInput (item) {
      // console.log(item)
      // console.log(this.symbol)
      var tmp = JSON.parse(JSON.stringify(item))
      if (!tmp.includes(this.symbol)) {
        // this.symbol = null
        this.cbComparison = false
      } else {
        this.cbComparison = true
      }
    }
  },
  created() {
    if (this.product.symbol) {
      this.symbol = this.product.symbol
    }
    // console.log(this.zalogowany)
  },
};
</script>

<style scoped>
.price {
  position: absolute;
  bottom: 0px;
  left: 10px;
  color: brown;
  font-weight: 700;
  font-size: 16px;
  margin: 0px;
}
.textPrice {
  color: #8a8a8a;
  font-size: 13px;
  font-weight: lighter;
}
.md-dialog {
  width: 100%;
  /* max-width: 1000px; */
  max-width: 100%;
}
.md-dialog img{
  height: auto;
  margin: 0px auto;
  padding: 30px;
  max-height: 710px;
}
.md-dialog-container {
  width: 1000px !important;
  max-width: 1000px !important;
}
.md-title {
  font-size: 16px;
}
.md-accent {
    margin: 24px;
    position: absolute;
    margin: auto 0px;
    z-index: 12;
    top: 50%;
    left: 50%;
    -webkit-transform: scale(2) !important;
    transform: scale(2) !important;
}
.md-dialog-actions {
  width: 100px;
  position: absolute;
  right: 10px
}
svg {
    font-size: 24px;
    position: absolute;
    right: 5px;
    width: 24px;
    bottom: 60px;
    color: #959393;
    padding: 0px;
    margin: 7px;
}
svg:hover {
  color: #448aff;
  transform: scale(1.2);
}
#tabs-content {
  width: 100%;
  float: none;
  display: block;
}
.tabs {
  width: 12px;
  height: 12px;
  float: right;
  margin-left: 2px;
  cursor: pointer;
}

.tabs-sale {
  background: #04a9e6;
}
.tabs-reduce {
  background: #59bf8d;
}
.tabs-rises {
  background: #dc3545;
}
.tabs-news {
  background: #fbca3f;
}
.tabs-promotion {
  background: #0377f2;
}
.tabs-phone {
  background: #6868b1;
}

.imgBox {
  width: 210px;
  margin: 0px auto;
  height: 175px;
}
.pic {
  max-width: 100%;
  max-height: 90%;
  object-position: center;
  object-fit: contain;
}
.item {
  background: #e3e3e3;
  padding: 4px;
  width: 250px;
  height: 220px;
  margin: 5px;

  line-height: 15px;
  color: black;
  font-weight: bold;
  font-size: 0.7em;
  text-align: center;
}
.item ul {
  list-style: none;
  padding: 0px;
}

.float-item {
  float: left;
}
/*inline-block*/
.inline-b {
  max-width: 1200px;
  margin: 0 auto;
}
.inline-b-item {
  display: inline-block;
}

/*Flexbox*/
.flex {
  padding: 0;
  margin: 0;
  list-style: none;

  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  /* -webkit-flex-flow: row wrap; */
  justify-content: space-around;
}

.card-expansion {
  height: 480px;
}

.md-card {
  width: 265px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
  height: 265px;
  position: relative;
}
.md-card-header {
  padding: 12px 12px 0px;
  height: 70px;
  margin: 0px;
}
.md-card-header span {
  font-size: 12px;
  margin-bottom: 6px;
  right: 0px;
  display: block;
  text-align: right;
  color: #ccc;
}
.md-card .md-title {
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  top: 8px;
  position: absolute;
}
.md-card .md-title:hover {
  color: #07548b;
}

.md-card .md-subhead {
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 14px;
  float: none;
  display: inline-block;
  position: relative;
  top: 14px;
  color: gray;
}
.md-card-media {
  width: 100%;
  padding: 4px;
  height: 138px;
}
.md-card a {
  margin: 0px;
}

.md-theme-default a:not(.md-button):hover {
  color: #07548b;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue